<div>
  <div>
    <button
      mat-button
      color="primary"
      (click)="landingPage()"
      class="bold-button"
      *ngIf="!currentUser?.IsLocked"
    >
      Home
    </button>
  </div>
  <img src="../assets/images/NWMO-full-name-logo.png" alt="NWMO Logo" />
  <div>
    <button
      mat-button
      color="primary"
      (click)="goToAdminCenter()"
      class="bold-button"
      *ngIf="currentUser?.IsAdmin && !currentUser?.IsLocked"
    >
      Admin Center
    </button>
  </div>
</div>
